import React, { forwardRef } from "react";
import { Col, Row } from "react-bootstrap";
import {
  getFullNameUser,
  numberWithCommas,
} from "../../Helpers/Utils/Common";

const PrintCategory = forwardRef((props) => {
  return (
    <div className="">
      <div className="print-receipt">
      <Row>
        <label className="print-text-category">{window.company_name}</label>
      </Row>
      <Row>
        <label className="print-text-category">{window.company_address}</label>
      </Row>
      <Row>
        <label className="print-text-category">
          DATE FROM: {props.filter.date_from}
        </label>
      </Row>
      <Row>
        <label className="print-text-category">
          DATE TO: {props.filter.date_to}
        </label>
      </Row>
      <Row>
        <label className="print-text-category">
          CASHIER: {getFullNameUser()}
        </label>
      </Row>
      <Row className="mt-4">
        {props.tab === "hourly" ? (
          <Col className="d-flex justify-content-center print-text-category">
            <strong>Hourly Sales Report</strong>
          </Col>
        ) : props.tab === "resto" ? (
          <Col className="d-flex justify-content-center print-text-category">
            <strong>RESTO MENU ITEM SALES REPORT</strong>
          </Col>
        ) : (
          <div>
          <Col xs={12} className="d-flex justify-content-center print-text-category">
            <strong>DAILY MENU ITEM SALES REPORT</strong>
          </Col>
          <Col xs={12} className="d-flex justify-content-end print-text-category mt-3">
            <strong>{`TOTAL SALES: ${numberWithCommas(props.totalSales)}`}</strong>
          </Col>
          </div>
        )}
        <hr />
      </Row>

      {props.data2.map((data) => {
        return (
          <div>
            {data.items && data.items.length > 0 && (
              <div>
                {props.tab === "resto" ? (
                  <Row className="">
                    <Col xs={4} className="print-text-category">
                      <strong>{data.name.toUpperCase()}</strong>
                    </Col>
                    <Col
                      xs={3}
                      className="d-flex justify-content-center print-text-category"
                    >
                      ITEM CODE
                    </Col>
                    <Col
                      xs={1}
                      className="d-flex justify-content-center print-text-category"
                    >
                      QTY
                    </Col>
                    <Col
                      xs={4}
                      className="d-flex justify-content-end print-text-category text-end"
                    >
                      SALES :{" "}
                      {numberWithCommas(
                        data.items && data.items.length > 0
                          ? data.items
                              .map((item) => parseFloat(item.total_amount))
                              .reduce((a, b) => a + b, 0)
                              .toFixed(2)
                          : "0.00"
                      )}
                    </Col>
                  </Row>
                ) : (
                  <Row className="">
                    <Col xs={5} className="print-text-category">
                      <strong>{data.name.toUpperCase()}</strong>
                    </Col>
                    <Col
                      xs={2}
                      className="d-flex justify-content-center print-text-category"
                    >
                      QTY
                    </Col>
                    <Col
                      xs={5}
                      className="d-flex justify-content-end print-text-category text-end"
                    >
                      SALES :{" "}
                      {numberWithCommas(
                        data.items && data.items.length > 0
                          ? data.items
                              .map((item) => parseFloat(item.total_amount))
                              .reduce((a, b) => a + b, 0)
                              .toFixed(2)
                          : "0.00"
                      )}
                    </Col>
                  </Row>
                )}
                <Row className="mb-3">
                  {data.items &&
                    data.items.map((item) => (
                      <div>
                        {props.tab === "resto" ? (
                          <Row key={item.menu_name} className="ms-1 pt-1">
                            <Col xs={4} className="print-text-category">
                              {item.menu_name}
                            </Col>
                            <Col xs={3} className="print-text-category">
                              B09233
                            </Col>
                            <Col
                              xs={1}
                              className="d-flex justify-content-center print-text-category"
                            >
                              {item.total_qty}
                            </Col>
                            <Col
                              xs={4}
                              className="d-flex justify-content-end print-text-category"
                            >
                              {numberWithCommas(item.total_amount)}
                            </Col>
                          </Row>
                        ) : (
                          <Row key={item.menu_name} className="ms-1 pt-1">
                            <Col xs={5} className="print-text-category">
                              {item.menu_name}
                            </Col>
                            <Col
                              xs={2}
                              className="d-flex justify-content-center print-text-category"
                            >
                              {item.total_qty}
                            </Col>
                            <Col
                              xs={5}
                              className="d-flex justify-content-end print-text-category"
                            >
                              {numberWithCommas(item.total_amount)}
                            </Col>
                          </Row>
                        )}
                      </div>
                    ))}
                </Row>
              </div>
            )}
          </div>
        );
      })}
    </div>
    </div>
  );
});

export default PrintCategory;
